// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"f6461d9c75d574bb1c69","738":"c0eb7adbd6a74e411ab7","765":"85e2cb3a12e4732aa483","852":"b41565d76cae68a33c15"}[chunkId] + ".bundle.js";
};